import { Box, SxProps, Theme, Typography } from '@mui/material'
import { useEffect } from 'react'
import { useDropzone } from 'react-dropzone'

import { BUTTON_BORDER_RADIUS } from 'providers/material-ui/theme/constants'

const sx = (theme: Theme): SxProps => ({
  backgroundColor: theme.palette.background.default,
  borderColor: theme.palette.grey[400],
  borderRadius: BUTTON_BORDER_RADIUS / 4,
  borderStyle: 'dashed',
  borderWidth: 2,
  px: 2,
  py: 4,
})

const ACCEPTED_FILE_TYPES = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
}

type Props = {
  file?: File
  hint: string
  onChange: (file: File) => void
}

export const DropZone = ({ file, hint, onChange }: Props): React.JSX.Element => {
  const { acceptedFiles, getInputProps, getRootProps } = useDropzone({
    accept: ACCEPTED_FILE_TYPES,
    multiple: false,
  })

  useEffect(() => {
    if (acceptedFiles.length > 0) {
      onChange(acceptedFiles[0])
    }
  }, [acceptedFiles])

  return (
    <Box {...getRootProps()}>
      <Box
        data-cy='drop-zone-container'
        sx={theme => ({ ...sx(theme) })}
      >
        <input
          {...getInputProps()}
          data-cy='drop-zone-input'
        />
        <Typography align='center'>
          <Typography align='center'>{file ? file.name : hint}</Typography>
        </Typography>
      </Box>
    </Box>
  )
}
